import { render, staticRenderFns } from "./PartnerDetailsPage.vue?vue&type=template&id=1ef963e0&scoped=true&"
import script from "./PartnerDetailsPage.vue?vue&type=script&lang=ts&"
export * from "./PartnerDetailsPage.vue?vue&type=script&lang=ts&"
import style0 from "./PartnerDetailsPage.vue?vue&type=style&index=0&id=1ef963e0&scoped=true&lang=css&"
import style1 from "./PartnerDetailsPage.vue?vue&type=style&index=1&id=1ef963e0&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ef963e0",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VDivider } from 'vuetify/lib/components/VDivider';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSelect } from 'vuetify/lib/components/VSelect';
installComponents(component, {VBtn,VContainer,VDivider,VIcon,VRow,VSelect})
